export const useSidebar = createGlobalState(() => {
  const { mdAndUp } = useLayout()
  const [isOpen, toggle] = useToggle(false)
  const isSearchOpen = ref(false)

  whenever(mdAndUp, () => (isSearchOpen.value = false))

  return { isOpen, isSearchOpen, toggle }
})
